goog.declareModuleId('yext.ui.components.Tab');

/**
 * @fileoverview A component intended to be passed as a child of the Tabs component. It should never
 * directly be rendered but instead should hold a child component of its own which will be rendered
 * by Tabs.
 *
 * @author Justin Mancusi (jmancusi@yext.com)
 */

/**
 * @param {{
 *   imagePath?: string,
 *   label: React.ReactNode,
 *   id: string,
 *   tid?: string,
 *   pendoId?: string,
 *   disabled?: boolean,
 *   children?: React.ReactNode,
 * }} props
 * @return {React.ReactElement}
 */
export const Tab = props => {
  throw new Error(
    'Tab should never be directly rendered. Instead, it should be passed as a child of the `Tabs` ' +
    'component',
  );
};
